module.exports = "<chat-users [users]=\"users\"></chat-users>\r\n<chat-body [messages]=\"messages\"></chat-body>\r\n<chat-form></chat-form>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/chat/chat/chat.component.html
// module id = 897
// module chunks = 85